import zhCN from './locales/zh-CN.js'
import en from './locales/en.js'
import userPagesZh from './locales/userPages.zh-CN.js'
import userPagesEn from './locales/userPages.en.js'
import knowledgeMapZh from './locales/knowledgeMapPages.zh-CN.js'
import knowledgeMapEn from './locales/knowledgeMapPages.en.js'

function mergeLocale(base, ...extensions) {
  let result = { ...base }
  for (const extension of extensions) {
    for (const [key, value] of Object.entries(extension)) {
      if (
        value &&
        typeof value === 'object' &&
        !Array.isArray(value) &&
        typeof result[key] === 'object' &&
        result[key] !== null &&
        !Array.isArray(result[key])
      ) {
        result[key] = mergeLocale(result[key], value)
      } else {
        result[key] = value
      }
    }
  }
  return result
}

export default {
  'zh-CN': mergeLocale(zhCN, userPagesZh, knowledgeMapZh),
  en: mergeLocale(en, userPagesEn, knowledgeMapEn)
}
